import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { Maximize, UploadCloud, Expand } from "lucide-react";
import ReviewPopup from "./review-popup";
import DocumentPreview from "../Create-Investment/documentpreview";
import ActivityLog from "../../Components/ActivityLog/activity-log";
import { useDispatch, useSelector } from "react-redux";
import StatusButton from "../../Components/Onbaording/status-button";
import FileUploadDisplay from "../../Components/Onbaording/file-display";
import MindmapTree from "../../Components/Onbaording/onboarding-tree";
import { useToast } from "../../Utils/toastContext";
import SectionStatusGrid from "../../Components/Onbaording/status-section";
import { debounce } from "lodash";

const ReviewKYCCorporate = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const buttonRefs = useRef({});
  const dropdownRef = useRef();
  const location = useLocation();
  const navigate = useNavigate();
  const { customerId } = useParams();
  const roleName = useSelector((state) => state.user.roleName);
  const [showPopup, setShowPopup] = useState(false);
  const [abnStatus, setAbnStatus] = useState("");
  const [investmentAmount, setInvestmentAmount] = useState(null);
  const [businessNature, setBusinessNature] = useState(null);
  const [refNumber, setRefNumber] = useState(new Array(7).fill(""));
  const [fileCompanyOrganisationalChart, setFileCompanyOrganisationalChart] =
    useState(null);
  const [fileAccountantCertificate, setFileAccountantCertificate] =
    useState(null);
  const [fileIncorporationCertificate, setFileIncorporationCertificate] =
    useState(null);
  const [fileCertificateOfIncumbency, setFileCertificateOfIncumbency] =
    useState(null);
  const [thpDescription, setThpDescription] = useState("");
  const [fileUboCertificate, setFileUboCertificate] = useState(null);
  const [fileShareholderCertificate, setFileShareholderCertificate] =
    useState(null);
  const updateFieldStatus = useSelector(
    (state) => state.deletedAccount.updateFieldStatus,
  );
  const [fileProof, setFileProof] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [description, setDescription] = useState("");
  const [photoIdSecond, setphotoIdSecond] = useState(2);
  const [companyTypeText, setCompanyTypeText] = useState("");
  const [principalAddress, setPrincipalAddress] = useState("");
  const [stockRegistered, setStockRegistered] = useState("");
  const [stockExchangeText, setStockExchangeText] = useState("");
  const [arbn, setArbn] = useState("");
  const [preselectedSignatory, setPreselectedSignatory] = useState({});
  const [loading, setLoading] = useState(false);
  const [layers, setLayers] = useState([]);
  const [ticketLink, setTicketLink] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [lastNameSignup, setLastNameSignup] = useState("");
  const [firstNameSignup, setFirstNameSignup] = useState("");
  const [email, setEmail] = useState("");
  const [companyRegistrationNumber, setCompanyRegistrationNumber] =
    useState("");
  const [foreignAddress, setForeignAddress] = useState("");
  const [options, setOptions] = useState([]);
  const [webLink, setWebLink] = useState("");
  const [signatoryEmail, setSignatoryEmail] = useState("");
  const [foreignRegistered, setForeignRegistered] = useState("");
  const [isActivityLogOpen, setIsActivityLogOpen] = useState(false);
  const [fileThirdParty, setFileThirdParty] = useState(null);
  const [personalDataIdText, setPersonalDataIdText] = useState("");
  const [fileActivityEvidence, setFileActivityEvidence] = useState(null);
  const [filePublicDocument, setFilePublicDocument] = useState(null);
  const [signatories, setSignatories] = useState([]);
  const [fileTicket, setFileTicket] = useState(null);
  const [businessNatureText, setBusinessNatureText] = useState("");
  const [DoI, setDoI] = useState("");
  const [EIN, setEIN] = useState("");
  const [stateText, setStateText] = useState("");
  const [acn, setAcn] = useState("");
  const [loadingUpdate, setLoadingUpdate] = useState(false);

  const [customDate, setCustomDate] = useState("");
  const [formattedDOI, setFormattedDOI] = useState("");
  const [businessRegistrationNumber, setBusinessRegistrationNumber] =
    useState("ACB2231");
  const [fileDriverLinsenceFrontSecond, setFileDriverLinsenceFrontSecond] =
    useState(null);
  const [filePhotographicIdSecond, setfilePhotographicIdSecond] =
    useState(null);
  const [expiryDate, setExpiryDate] = useState("02/12/2026");
  const [expiryDateSecond, setExpiryDateSecond] = useState("");
  const [bankdata, setBankdata] = useState([]);
  const [fileDriverLinsenceBackFirst, setFileDriverLinsenceBackFirst] =
    useState(null);
  const [fileDriverLinsenceBackSecond, setFileDriverLinsenceBackSecond] =
    useState(null);
  const [fileDriverLinsenceFrontFirst, setFileDriverLinsenceFrontFirst] =
    useState(null);
  const [fileDriverLinsenceFront, setFileDriverLinsenceFront] = useState(null);
  const [fileDriverLinsenceBack, setFileDriverLinsenceBack] = useState(null);
  const [applicantCountry, setApplicantCountry] = useState(1);
  const [socialSecurityNumber, setSocialSecurityNumber] = useState("");
  const [abn, setAbn] = useState(null);
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [businessName, setBusinessName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [taxResidentCountryText, setTaxResidentCountryText] = useState("US");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [accountType, setAccountType] = useState(null);
  const [currentDocument, setcurrentDocument] = useState({});
  const [openDropdown, setOpenDropdown] = useState(false);
  const [filter, setFilter] = useState("");
  const [status, setStatus] = useState("resubmit");
  const [isOpen, setIsOpen] = useState(false);
  const [transactionLevel, setTransactionLevel] = useState("");

  const [toCurrencyText, setToCurrencyText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, settotalPages] = useState(0);
  const [showRecords, setShowRecords] = useState(10);
  const [totalCount, settotalCount] = useState(0);
  const [image, setImage] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [licenseNumber, setLicenseNumber] = useState(null);
  const [countryCodeText, setCountryCodeText] = useState("Australia");
  const [registeredAddress, setRegisteredAddress] = useState("");
  const [fileArticle, setFileArticle] = useState(null);
  const [shareholders, setShareholders] = useState([
    {
      id: 771,
      name: "Ann711",
      type: "Individual",
      shares: 25,
      email: "f@n.com",
    },
    {
      id: 255,
      name: "XYZ main",
      type: "Corporate",
      shares: 40,
      email: "f@n.com",
    },
    {
      id: 3,
      name: "Carol",
      type: "Trust",
      shares: 40,
      email: "f@n.com",
    },
  ]);
  const [collapsedLayers, setCollapsedLayers] = useState({}); // { layerName: true/false }

  const [filePhotographicId, setFilePhotographicId] = useState(null);
  const [isOpenAction, setIsOpenAction] = useState(false);
  const statusTextMap = {
    "to-review": "To Review",
    "in-progress": "In Progress",
    resubmit: "Sent For Resubmit",
    approval: "Approval",
  };
  const formData = {};
  const [selected, setSelected] = useState(null);
  const [minimumInvestment, setminimumInvestment] = useState(0);
  const [fileAttorney, setFileAttorney] = useState(null);
  const [accounts, setAccounts] = useState([]);
  const [limitDurationLabel, setLimitDurationLabel] = useState("Per Day");
  const [businessActivity, setBusinessActivity] = useState("smaple text");
  const [otherActivity, setOtherActivity] = useState("");
  const [taxId, setTaxId] = useState("");
  const [preview, setPreview] = useState("/avatar.svg");

  const handleStatusClick = (docData, fieldText, fieldValue, fieldType) => {
    setCurrentField(docData);
    setCurrentFieldName(fieldText);
    setCurrentFieldValue(fieldValue);
    setCurrentFieldType(fieldType);
    setShowPopup(true);
  };
  const [members, setMembers] = useState([
    {
      firstName: "abc",
      dob: "test",
      email: "abc@gmail.com",
      countryCode: "AU(+61)",
      mobile: "7766",
      address: "street1 2",
      accountType: "individual",
      errors: {
        email: "",
        mobile: "",
      },
    },
    {
      firstName: "xyz",
      dob: "test",
      email: "xyz@gmail.com",
      countryCode: "AU(+61)",
      mobile: "7766",
      address: "street1 2",
      accountType: "individual",
      errors: {
        email: "",
        mobile: "",
      },
    },
  ]);
  const [signatoryTypeLabel, setSignatoryTypeLabel] = useState(1);
  const [signatoryType, setSignatoryType] = useState(1);
  const [companySecretary, setCompanySecretary] = useState("");
  const [companyWebsite, setCompanyWebsite] = useState("");
  const [investmentAmountText, setInvestmentAmountText] = useState("");
  const [fileFinancialService, setFileFinancialService] = useState(null);
  const [ifApplicable, setIfApplicable] = useState(null);
  const [hasLicense, setHasLicense] = useState("yes");
  const [currentField, setCurrentField] = useState({});
  const [currentFieldName, setCurrentFieldName] = useState("");
  const [currentFieldValue, setCurrentFieldValue] = useState("");
  const [currentFieldType, setCurrentFieldType] = useState("");
  const [source, setSource] = useState("");
  const [jurisdiction, setJurisdiction] = useState("");
  const [fileAdviceStatement, setFileAdviceStatement] = useState(null);
  const [stockexchangeLocation, setStockexchangeLocation] = useState("");
  const [fileForeignRegistration, setFileForeignRegistration] = useState(null);
  const [fileLicense, setFileLicense] = useState(null);
  const [accountTypeLabel, setAccountTypeLabel] = useState("Individual");
  const [fullName, setFullName] = useState("John Mayer");
  const [formerNames, setFormerNames] = useState("John Mayer");
  const [clientNo, setClientNo] = useState("CM0013189P");
  const [recommendedBy, setRecommendedBy] = useState("");
  const [agentName, setAgentName] = useState("");
  const [agentAddress, setAgentAddress] = useState("");
  const [businessActivityText, setBusinessActivityText] =
    useState("smaple text");
  const [fileCompanyRegistration, setFileCompanyRegistration] = useState(null);
  const [fileDisclosure, setFileDisclosure] = useState(null);
  const [fileExtractDocument, setFileExtractDocument] = useState({
    verification_id: null,
    value: null,
    status: "pending",
    rejection_reason: null,
    rejection_comment: null,
    rejection_timestamp: null,
    rejected_by: null,
    comments: [],
  });
  const { showToast } = useToast();
  const [statusData, setStatusData] = useState([]);
  const [data, setData] = useState([
    {
      name: "ABC Company",
      type: "Corporate",
      children: [
        { name: "Ann", type: "Individual", children: [] },
        {
          name: "XYZ",
          type: "Corporate",
          children: [
            {
              name: "DEF",
              type: "Corporate",
              children: [
                {
                  name: "Emily Johanson",
                  type: "Individual",
                  children: [],
                },
                { name: "Dalia limited", type: "Corporate", children: [] },
                { name: "Noah", type: "Individual", children: [] },
              ],
            },
            { name: "Aron", type: "Individual", children: [] },
          ],
        },
        { name: "Carol", type: "Trust", children: [] },
      ],
    },
    {
      name: "You trust",
      type: "Trust",
      children: [
        {
          name: "Subsidiary A",
          type: "Corporate",
          children: [
            { name: "John Doe", type: "Individual", children: [] },
            { name: "Jane Smith", type: "Individual", children: [] },
          ],
        },
        { name: "Subsidiary B", type: "Trust", children: [] },
      ],
    },
    {
      name: "John Doe",
      type: "Individual",
      children: [],
    },
  ]);

  const NodeLegend = () => {
    const legendItems = [
      { type: "Corporate", color: "#005A9C" }, // deep navy
      { type: "Individual", color: "#047857" }, // green
      { type: "Trust", color: "#DB2777" }, // pink
    ];

    return (
      <div
        style={{
          position: "absolute",
          top: 400,
          right: 30,
          background: "white",
          borderRadius: 10,
          padding: "10px 15px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          zIndex: 10,
        }}
      >
        <h4 style={{ marginBottom: 8, fontWeight: 600 }}>Details</h4>
        {legendItems.map((item) => (
          <div
            key={item.type}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 6,
            }}
          >
            <div
              style={{
                width: 18,
                height: 18,
                borderRadius: 4,
                background: item.color,
                marginRight: 8,
                border: "1px solid rgba(0,0,0,0.2)",
              }}
            ></div>
            <span style={{ fontSize: 14 }}>{item.type}</span>
          </div>
        ))}
      </div>
    );
  };
  function getNodeStyle(node) {
    const layerColors = ["#f59e0b", "#3b82f6", "#10b981", "#ef4444"];

    // Safely calculate the background gradient
    const color = layerColors[(node.data.layer ?? 0) % layerColors.length]; // fallback to 0 if layer is missing

    const background = `linear-gradient(135deg, ${color}, #000)`; // gradient from color → black

    return {
      background,
      borderRadius: 12,
      padding: "12px 16px",
      color: "white",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      fontWeight: 600,
      fontSize: 14,
      textAlign: "center",
      minWidth: 140,
      transition: "transform 0.2s ease",
    };
  }
  const updateApplication = async (action) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      action == "approve"
        ? `${BASE_URL}/v1/onboarding/admin/kyc-review/approve-application`
        : `${BASE_URL}/v1/onboarding/admin/kyc-review/reject-application`;
    const bodyData = {
      user_id: customerId,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleUpdateApplication = useCallback(
    debounce(async (e, action) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updateApplication(action);
        if (response.status == 200) {
          toastMessage = {
            message: response.message,
            type: "success",
          };

          navigate("/customer-list");
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (error) {
        toastMessage = { message: error.message, type: "error" };
      } finally {
        setLoadingUpdate(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 1000); // Small delay if needed
        }
      }
    }, 1000),
    [customerId], // Dependencies
  );
  const statusColorMap = {
    "to-review":
      "border-2 border-[#F77E27] text-[#F77E27] bg-[#F77E27] bg-opacity-30",
    "in-progress":
      "border-2  border-[#FFC421] text-[#FFC421] bg-[#FFC421] bg-opacity-30",
    resubmit:
      "border-2  border-[#3047EC] text-[#3047EC] bg-[#3047EC] bg-opacity-30",
    approval:
      "border-2  border-[#CC00FF] text-[#CC00FF] bg-[#CC00FF] bg-opacity-30",
  };
  // Recursively build nodes & edges from API data
  const [graphNodes, setGraphNodes] = useState([]);
  const [graphEdges, setGraphEdges] = useState([]);
  const [showVisualLink, setShowVisualLink] = useState(false);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpenAction(false);
      }
      const isOutside = !Object.values(buttonRefs.current).some((ref) =>
        ref?.contains(event.target),
      );
      if (isOutside) {
        setDropdownOpen(null); // Close dropdown if clicked outside
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const handleDropdownToggleStatus = () => {
    setDropdownOpen((prev) => !prev);
  };
  const handleFileClick = (docData) => {
    setcurrentDocument(docData);
    setIsModalOpen(true);
  };
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  const kycheaders = [
    "",
    "Full Name",
    "Date Of Birth",
    "Email Address",
    "Mobile Number",
    "Account Type",
  ];
  const secondheadersWithAddress = [
    "",
    "First Name",
    "Last Name",
    "Email Address",
    "Mobile Number",
    "Residential Address",
    "Account Type",
  ];

  useEffect(() => {
    const n = [];
    const e = [];
    let idCounter = 0;

    const buildGraph = (node, parentId = null, depth = 0, xOffset = 0) => {
      const id = `${idCounter++}`;
      n.push({
        id,
        data: { label: `${node.name} (${node.type})` },
        position: { x: xOffset * 250, y: depth * 150 },
        typeNode: node.type, // <-- store the type here
      });

      if (parentId) {
        e.push({
          id: `${parentId}-${id}`,
          source: parentId,
          target: id,
          animated: true,
        });
      }

      node.children?.forEach((child, idx) =>
        buildGraph(
          child,
          id,
          depth + 1,
          xOffset + idx - node.children.length / 2,
        ),
      );
    };

    data.forEach((root, idx) => buildGraph(root, null, 0, idx * 3)); // <== iterate roots
    setGraphNodes(n);
    setGraphEdges(e);
  }, [data]);
  const handleCollapseAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = true; // collapsed
    });
    setCollapsedLayers(newState);
  };

  const handleExpandAll = () => {
    const newState = {};
    layers.forEach((l) => {
      newState[l.id] = false; // expanded
    });
    setCollapsedLayers(newState);
  };
  const handleDropdownToggle = () => {
    if (openDropdown) {
      setOpenDropdown(false); // Close if already open
    } else {
      setOpenDropdown(true); // Open the dropdown for the specific row
    }
  };
  const togglePopup = () => setIsOpen(!isOpen);

  const AllStatus = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
  ];
  const handleStatusChange = async (e) => {
    e.preventDefault();
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later",
      );
    }
  };
  const mapApiLayersToUiLayers = (apiLayers = []) => {
    return apiLayers.map((layer) => {
      const hasTabs = Array.isArray(layer.tabs);

      // Case 1: entities-based layer (NO tabs)
      if (!hasTabs) {
        return {
          id: layer.layer_number, // ✅ stable key
          layerName: `Interconnection Layer ${layer.layer_number}`,
          hasTabs: false,
          groups: [
            {
              parent: null,
              shareholders: (layer.entities || []).map((e) => ({
                id: e.id,
                name: e.name,
                type: e.shareholder_type?.id || "",
                typeName: e.shareholder_type?.name || "",
                shares: e.percentage_ownership,
                email: e.email,
                userId: e.shareholder_user_id,
                status: e.user_status,
                errors: {},
              })),
            },
          ],
        };
      }

      // Case 2: tabs-based layer
      return {
        id: layer.layer_number, // ✅ stable key
        layerName: `Interconnection Layer ${layer.layer_number}`,
        hasTabs: true,
        groups: layer.tabs.map((tab) => ({
          parent: {
            id: tab.parent_id,
            name: tab.parent_name,
          },
          shareholders: (tab.group?.shareholders || []).map((s) => ({
            id: s.id,
            name: s.name,
            type: s.shareholder_type?.id || "",
            typeName: s.shareholder_type?.name || "",
            shares: s.percentage_ownership,
            email: s.email,
            userId: s.shareholder_user_id,
            status: s.user_status,
            errors: {},
          })),
        })),
      };
    });
  };
  const getAllDetails = async () => {
    try {
      const response = await GetAPIcalls(
        `/v1/onboarding/admin/kyc-review/${customerId}`,
      );

      if (response.status == 200) {
        // Open account status
        setFirstNameSignup(
          response.data.open_account_information.first_name.value,
        );
        setLastNameSignup(
          response.data.open_account_information.last_name.value,
        );
        setEmail(response.data.open_account_information.email_address.value);
        setMobileNumber(
          response.data.open_account_information.country_code.value +
            response.data.open_account_information.mobile_number.value,
        );
        setCustomerType(
          response.data.open_account_information.account_type.value,
        );

        //Corporate information
        setPreview(response.data.corporate_information.company_logo_url);
        setAccountTypeLabel(
          response.data.corporate_information.corporate_type.value.name,
        );
        setAccountType(
          response.data.corporate_information.corporate_type.value.id,
        );
        setFullName(response.data.corporate_information.company_full_name);
        setFormerNames(
          response.data.corporate_information.former_trading_names,
        );
        setClientNo(response.data.corporate_information.client_id.value);
        setRecommendedBy(response.data.corporate_information.recommended_by);
        setBusinessNature(response.data.corporate_information.business_nature);
        setBusinessActivity(
          response.data.corporate_information.business_activities,
        );

        const date = new Date(
          response.data.corporate_information.date_of_incorporation.value,
        );
        const formattedDate = date.toLocaleDateString("en-GB");
        setDoI(response.data.corporate_information.date_of_incorporation);
        setFormattedDOI(formattedDate);
        setForeignRegistered(
          response.data.corporate_information.is_registered_foreign_body
            .value == true
            ? "yes"
            : "no",
        );
        setEIN(response.data.corporate_information.foreign_ein);
        setCompanyRegistrationNumber(
          response.data.corporate_information.foreign_registration_number,
        );
        if (response.data.corporate_information.corporate_type.value.id != 1) {
          setForeignAddress(
            response.data.corporate_information.country_of_formation_address,
          );
        }
        setCompanyTypeText(
          response.data.corporate_information.registered_by_asic_as,
        );
        setCountryCodeText(
          response.data.corporate_information.country_of_domicile,
        );
        setRegisteredAddress(
          response.data.corporate_information.registered_office_address,
        );
        setPrincipalAddress(
          response.data.corporate_information.principal_place_address,
        );

        if (response.data.corporate_information.corporate_type.value.id == 1) {
          setStateText(
            response.data.corporate_information.state_or_territory_in_aus,
          );
          setAbn(response.data.corporate_information.abn);
          setAcn(response.data.corporate_information.acn);
        }

        setStockRegistered(
          response.data.corporate_information?.is_listed_on_comparable_exchange
            ?.value == true
            ? "No"
            : "Yes",
        );
        setStockExchangeText(
          response.data.corporate_information.relevant_stock_exchange,
        );
        setArbn(response.data.corporate_information.arbn);
        setCompanySecretary(
          response.data.corporate_information.company_secretary_name,
        );
        setCompanyWebsite(response.data.corporate_information.company_website);
        setToCurrencyText(
          response.data.corporate_information.default_investment_currency,
        );
        setTransactionLevel(
          response.data.corporate_information.intended_transaction_behavior,
        );
        setSource(response.data.corporate_information.source_of_funds_origin);
        setInvestmentAmount(
          response.data.corporate_information.expected_investment_amount,
        );
        setAgentName(response.data.corporate_information.local_agent_full_name);

        if (response.data.corporate_information.local_agent_address) {
          setAgentAddress(
            response.data.corporate_information.local_agent_address,
          );
        }
        // Directors
        setSignatoryTypeLabel(
          response.data.directors_n_shareholders?.signatory_type?.value.name,
        );
        setSignatoryType(
          response.data.directors_n_shareholders?.signatory_type?.value.id,
        );
        // ─── 1 TO SIGN ────────────────────────────────────────────────
        const signatoryTypeValue =
          response.data.directors_n_shareholders?.signatory_type?.value;

        if (signatoryTypeValue.id === 1) {
          setSignatoryEmail(
            response.data.directors_n_shareholders?.signatories?.value?.[0] ||
              null,
          );

          let signatory =
            response.data.directors_n_shareholders.invitees.filter(
              (item) =>
                item.email ===
                response.data.directors_n_shareholders?.signatories?.value?.[0],
            );
          setPreselectedSignatory({
            value: signatory[0].email,
            label: signatory[0].first_name + signatory[0].last_name,
          });
        }

        // ─── Match signatories by email ───────────────────────────────

        // ─── Build invitee options once ───────────────────────────────
        let inviteeOptions =
          response.data.directors_n_shareholders.invitees?.map((invitee) => ({
            label: `${invitee.first_name} ${invitee.last_name}`,
            value: invitee.id,
            email: invitee.email,
          })) || [];
        const matchedInvitees = inviteeOptions.filter((invitee) =>
          response.data.directors_n_shareholders?.signatories?.value.includes(
            invitee.email,
          ),
        );
        setSignatories(response.data.directors_n_shareholders?.signatories);
        // ─── MULTIPLE / ALL TO SIGN ───────────────────────────────────
        switch (signatoryTypeValue.id) {
          case 2: // Selected signatories
            setSelectedOptions(matchedInvitees);
            break;

          case 3: // All invitees
            setSelectedOptions(inviteeOptions);
            setOptions(inviteeOptions);
            break;

          default:
            break;
        }
        setFileAttorney(
          response.data.directors_n_shareholders?.board_resolution_file,
        );
        setLimitDurationLabel(
          response.data.directors_n_shareholders?.transaction_limit_duration
            ?.value?.name,
        );
        setminimumInvestment(
          response.data.directors_n_shareholders?.transaction_limit_amount,
        );
        setCustomDate(
          response.data.directors_n_shareholders?.transaction_limit_expiry,
        );
        setMembers(
          response.data.directors_n_shareholders.invitees.map((item) => ({
            firstName: item.first_name, // or Date.now() if you want local-only IDs
            lastName: item.last_name,
            countryCode: item.country_code, // 1 = Individual, 2 = Corporate, 3 = Trust
            mobile: item.mobile_number,
            email: item.email,
            status: item.status,
            managingMember: item.is_managing_member,
            userId: item.user_id,
          })),
        );
        const uiLayers = mapApiLayersToUiLayers(
          response.data.directors_n_shareholders.shareholders.layers,
        );
        setLayers(uiLayers);

        // External Bank
        setBankdata(response.data.external_banks);

        //Cash account
        const existingAccount = response.data.cash_accounts.map((acc) => ({
          value: acc.currency,
          label: `${acc.currency.value.name}`,
          status: acc.currency.status,
          comments: acc.currency.comments,
        }));
        setAccounts(existingAccount);

        // Proof docs
        setIfApplicable(
          response.data.corporate_proof_documents.has_prosecution,
        );
        setDescription(
          response.data.corporate_proof_documents.prosecution_description,
        );
        setFileProof(
          response.data.corporate_proof_documents.prosecution_document,
        );
        setWebLink(response.data.corporate_proof_documents.website_link);
        setAbnStatus(response.data.corporate_proof_documents.abn_lookup_status);
        setFilePublicDocument(
          response.data.corporate_proof_documents.company_public_document,
        );
        setFileExtractDocument(
          response.data.corporate_proof_documents.asic_search_extract,
        );
        setFileAccountantCertificate(
          response.data.corporate_proof_documents.accountant_certificate,
        );
        setFileCompanyOrganisationalChart(
          response.data.corporate_proof_documents.company_organization_chart,
        );
        setFileIncorporationCertificate(
          response.data.corporate_proof_documents.certificate_of_incorporation,
        );
        let companyCategory =
          response.data.corporate_information.corporate_type.value.id;
        let companyType =
          response.data.corporate_information.registered_by_asic_as.value.id;
        setTicketLink(response.data.corporate_proof_documents.ticket_number);
        if (companyCategory != 1) {
          setFileTicket(
            response.data.corporate_proof_documents.ticket_file_upload,
          );
        }
        if (companyCategory == 1 && companyType == 2) {
          setFileTicket(response.data.corporate_proof_documents.asx_document);
        }
        if (
          companyCategory == 2 ||
          (companyCategory == 3 && companyType == 2) ||
          (companyCategory == 1 && companyType == 1)
        ) {
          setFileCompanyRegistration(
            response.data.corporate_proof_documents.registration_certificate,
          );
          setFileDisclosure(
            response.data.corporate_proof_documents
              .beneficial_ownership_certificate,
          );
        }
        setFileShareholderCertificate(
          response.data.corporate_proof_documents.shareholder_certificate,
        );
        if (companyCategory != 1) {
          setFileCertificateOfIncumbency(
            response.data.corporate_proof_documents.certificate_of_incumbency,
          );
          setFileUboCertificate(
            response.data.corporate_proof_documents.ubo_certificate,
          );

          setFileArticle(
            response.data.corporate_proof_documents.articles_of_association,
          );
        }
        if (
          companyCategory == 1 ||
          (companyCategory == 3 && companyType == 1)
        ) {
          const proofDoc = response?.data?.corporate_proof_documents;
          const hasAfsl = proofDoc?.has_afsl.value;

          if (hasAfsl) {
            setHasLicense(hasAfsl);
            setFileLicense(proofDoc?.regulator_license_document);
          }
          setFileThirdParty(
            response.data.corporate_proof_documents.contract_document,
          );
          setThpDescription(
            response.data.corporate_proof_documents.contract_description,
          );
        }
        if (
          companyCategory == 2 ||
          (companyCategory == 3 && companyType == 2)
        ) {
          setFileForeignRegistration(
            response.data.corporate_proof_documents
              .foreign_registration_certificate,
          );
          setJurisdiction(
            response.data.corporate_proof_documents.primary_jurisdiction,
          );
          setStockexchangeLocation(
            response.data.corporate_proof_documents.stock_exchange_location,
          );
          setFileFinancialService(
            response.data.corporate_proof_documents.afsl_document,
          );
          setFileActivityEvidence(
            response.data.corporate_proof_documents.company_activities_evidence,
          );
          setFileAdviceStatement(
            response.data.corporate_proof_documents.statement_of_advice,
          );
        }
        setIsDataAvailable(true);
      }
    } catch (err) {
      setIsDataAvailable(false);
      showToast(err.message, "error");
    } finally {
    }
  };
  const getStatus = async () => {
    try {
      setLoading(true);
      const response = await GetAPIcalls(
        `/v1/onboarding/admin/kyc-review/${customerId}/sections`,
      );

      if (response.status == 200) {
        setStatusData(response.data);
      }
    } catch (err) {
      setStatusData([]);
      showToast(err.message, "error");
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 300);
    }
  };
  useEffect(() => {
    if (customerId || updateFieldStatus) {
      getStatus();
      getAllDetails();
    }
  }, [customerId, updateFieldStatus]);
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] p-4 bg-white rounded-lg shadow-lg  relative">
      {loadingUpdate && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      {loading ? (
        <div className="space-y-6">
          {/* Content Shimmer */}
          {[...Array(5)].map((_, idx) => (
            <div key={idx} className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gray-300 animate-shimmer"></div>
              <div className="h-4 w-full max-w-3xl bg-gray-300 rounded animate-shimmer"></div>
            </div>
          ))}

          {/* Buttons Shimmer */}
          <div className="flex flex-wrap gap-2 mt-4">
            <div className="h-10 w-48 bg-gray-300 rounded-xl animate-shimmer"></div>
            <div className="h-10 w-56 bg-gray-300 rounded-xl animate-shimmer"></div>
          </div>
        </div>
      ) : (
        <>
          {" "}
          <div className="w-full relative">
            <div className="flex flex-wrap justify-between items-center mb-4 border-b pb-5 border-gray-100">
              <div className="flex items-center">
                <img src="/note-2.svg" alt="Company Logo" className="mr-3" />
                <span className="font-medium lg:text-lg text-sm">
                  Review KYC
                </span>
              </div>
              <div className="flex gap-2 mt-4 md:mt-0">
                {roleName != "super_admin" && (
                  <button className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl">
                    <img
                      src="/send-message.svg"
                      alt="Add Icon"
                      className="mr-2"
                    />
                    <span className="lg:inline hidden pr-2">
                      Request Review Access
                    </span>
                  </button>
                )}
                <button className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl">
                  <img
                    src="/send-message.svg"
                    alt="Add Icon"
                    className="mr-2"
                  />
                  <span className="lg:inline hidden pr-2">
                    Check Matching Details
                  </span>
                  <span className="bg-[#FF5050] text-xs flex items-center justify-center text-white w-5 h-5 rounded-full ml-2">
                    2
                  </span>
                </button>
              </div>
            </div>
            <div>
              <div className="flex flex-wrap justify-between items-center mb-4">
                <div className="flex items-center w-full md:w-auto mb-4 md:mb-0">
                  <img
                    src="/avatar.svg"
                    alt="Profile"
                    className="h-10 w-10 rounded-full mr-2"
                  />
                  <div className="flex flex-col md:flex-row md:items-center w-full md:w-auto">
                    <h1 className="text-md font-medium mr-2">
                      {firstNameSignup} {lastNameSignup}
                    </h1>
                    <div className="relative w-full md:w-auto">
                      <div
                        ref={(el) => (buttonRefs.current[`status`] = el)}
                        className="relative w-full md:w-auto"
                      >
                        <button
                          onClick={() => handleDropdownToggleStatus()}
                          className={`w-full md:w-auto font-semibold h-8 rounded-xl text-xs px-2 py-2 flex justify-between items-center focus:outline-none transition-colors duration-200 ${
                            statusColorMap[status] ||
                            "border border-gray-300 text-gray-700 bg-white"
                          }`}
                        >
                          <span className="truncate mr-2">
                            {statusTextMap[status] || "Select Status"}
                          </span>
                          <img
                            src={
                              dropdownOpen
                                ? "/dropdown-up.svg"
                                : "/dropdown-down.svg"
                            }
                            alt="Dropdown Icon"
                            className={`h-5 w-5 flex-shrink-0 ml-auto object-scale-down object-center`}
                          />
                        </button>

                        {/* Dropdown menu */}
                        {dropdownOpen && (
                          <div className="font-semibold absolute mt-1 w-40  bg-white border border-gray-200 rounded-xl shadow-lg z-50">
                            {Object.entries(statusTextMap).map(
                              ([key, label]) => (
                                <div
                                  key={key}
                                  onClick={() => {
                                    setStatus(key);
                                    setDropdownOpen(false);
                                  }}
                                  className={`mx-2 px-2 py-1 text-[10px] cursor-pointer rounded-xl my-1 ${
                                    statusColorMap[key] ||
                                    "border border-gray-300 text-gray-700 bg-white"
                                  } hover:opacity-90 transition`}
                                >
                                  {label}
                                </div>
                              ),
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex space-x-2 w-full md:w-auto">
                  <button
                    onClick={() => {
                      setIsActivityLogOpen(true);
                    }}
                    className="flex text-sm font-medium items-center text-black bg-white border py-2 lg:px-4 px-1 rounded-xl w-full md:w-auto"
                  >
                    <img
                      src="/backward-10-seconds.svg"
                      alt="Add Icon"
                      className="mr-2"
                    />
                    <span className="inline pr-2">Activity Log</span>
                  </button>
                </div>
              </div>
              {isActivityLogOpen && (
                <ActivityLog
                  onClose={() => setIsActivityLogOpen(false)}
                  customerId={customerId}
                />
              )}
              <div className="flex mt-2 items-center  border-colour-custom space-x-2  pt-2 px-4">
                <h1 className="text-md font-medium mb-2 text-center">
                  Corporate Application Check List
                </h1>
              </div>{" "}
              <SectionStatusGrid sections={statusData} />
            </div>
            {isDataAvailable && (
              <>
                {/* Open Account Information */}
                <div className="w-full  p-4">
                  <div className="mt-2 border pb-4 pt-2 rounded-md">
                    <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                      <div className="flex text-black items-center space-x-2">
                        <img
                          src="/profile-circle-black.svg"
                          alt="User Avatar"
                          className="h-6 w-6 mb-2"
                        />
                        <h1 className="text-md font-medium mb-2">
                          {" "}
                          Open Account Information
                        </h1>
                      </div>
                    </div>
                    {/* Will add popup here */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                      {/* Column 1 */}
                      <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4">
                        <label className="text-sm text-[#A6A6A6]">
                          First Name
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {firstNameSignup}
                        </div>

                        <label className="mt-2 text-sm text-[#A6A6A6]">
                          Last Name
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {lastNameSignup}
                        </div>
                      </div>

                      {/* Column 2 */}
                      <div className="flex flex-col lg:pt-4 pt-0 sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <label className="text-sm text-[#A6A6A6]">Email</label>
                        <div className="text-sm break-all whitespace-normal max-w-full">
                          {email}
                        </div>

                        <label className="mt-2 text-sm text-[#A6A6A6]">
                          Mobile
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {mobileNumber}
                        </div>
                      </div>

                      {/* Column 3 */}
                      <div className="flex flex-col lg:pt-4 pt-0 px-4">
                        <label className="text-sm text-[#A6A6A6]">
                          Customer Type
                        </label>
                        <div className="text-sm break-words max-w-full">
                          {customerType}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* End  */}
                {/* Corporate Information */}
                <div className="bg-white border rounded-md p-4 mt-4">
                  <div className="flex justify-between items-start border-colour-custom px-4">
                    {/* Left Section: Icon + Heading */}
                    <div className="flex items-center space-x-2">
                      <img
                        src="/briefcase.svg"
                        alt="User Avatar"
                        className="h-6 w-6"
                      />
                      <h1 className="text-xl font-medium">
                        Corporate Information
                      </h1>
                    </div>
                  </div>

                  <div className="bg-white pb-4">
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                      <div className="flex flex-col px-4 pt-4">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center"
                          >
                            Company Logo
                          </label>
                          <StatusButton
                            status={preview.status}
                            count={preview.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                preview,
                                "Company Logo",
                                preview?.value?.presigned_url,
                                "",
                              )
                            }
                          />
                        </div>
                        <div className="relative flex-shrink-0 mb-4 lg:mb-0 mt-1 mr-6">
                          <img
                            src={preview?.value?.presigned_url}
                            alt={`${fullName}`}
                            className="w-20 h-20 rounded-full object-cover"
                          />
                        </div>
                        <label
                          htmlFor="advisorRefNumber"
                          className="mb-1 mt-4 text-sm text-[#A6A6A6]"
                        >
                          Advisor Ref No
                        </label>

                        <span>{refNumber}</span>
                        <label
                          htmlFor="companyCategory"
                          className="mb-1 mt-4 text-sm text-[#A6A6A6]"
                        >
                          Company Category
                        </label>

                        <span>{accountTypeLabel}</span>
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            Full Name of the Company
                          </label>
                          <StatusButton
                            status={fullName.status}
                            count={fullName.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                fullName,
                                "Full Name of the Company",
                                fullName.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{fullName.value}</span>
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            All Other Business Name(s)
                          </label>
                          <StatusButton
                            status={formerNames.status}
                            count={formerNames.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                formerNames,
                                "All Other Business Name(s)",
                                formerNames.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>
                          {Array.isArray(formerNames?.value)
                            ? formerNames.value.join(", ")
                            : ""}
                        </span>
                      </div>
                      <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        {" "}
                        {accountType != 1 && (
                          <>
                            <label
                              htmlFor="clientNo"
                              className="mb-1 text-sm text-[#A6A6A6]"
                            >
                              Client ID
                            </label>
                            <span>{clientNo}</span>

                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Recommended by
                              </label>
                              <StatusButton
                                status={recommendedBy?.status}
                                count={recommendedBy?.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    recommendedBy,
                                    "Recommended by",
                                    recommendedBy?.value.name,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{recommendedBy?.value?.name}</span>
                          </>
                        )}
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center"
                          >
                            Business Nature
                          </label>
                          <StatusButton
                            status={businessNature?.status}
                            count={businessNature?.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                businessNature,
                                "Business Nature",
                                businessNature?.value.name,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{businessNature?.value?.name}</span>
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center"
                          >
                            Business Activity
                          </label>
                          <StatusButton
                            status={businessActivity.status}
                            count={businessActivity.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                businessActivity,
                                "Business Activity",
                                businessActivity?.value?.name,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{businessActivity?.value?.name}</span>
                        {businessActivity?.value?.id == 6 && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Other Activity
                              </label>
                              <StatusButton
                                status={otherActivity.status}
                                count={otherActivity.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    otherActivity,
                                    "Other Activity",
                                    otherActivity.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{otherActivity.value}</span>
                          </>
                        )}
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            Company's Date of Incorporation
                          </label>
                          <StatusButton
                            status={DoI.status}
                            count={DoI.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                DoI,
                                "Company's Date of Incorporation",
                                formattedDOI,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{formattedDOI}</span>
                      </div>
                      <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                        {accountType == 1 && (
                          <>
                            <label
                              htmlFor="clientNo"
                              className="mb-1 text-sm text-[#A6A6A6]"
                            >
                              Client No
                            </label>
                            <span>{clientNo}</span>
                            <label
                              htmlFor="clientNo"
                              className="mb-1 text-sm mt-4 text-[#A6A6A6]"
                            >
                              Recommended by
                            </label>
                            <span>{recommendedBy?.value?.name}</span>
                          </>
                        )}
                        {accountType != 1 && (
                          <>
                            {" "}
                            <label
                              htmlFor="clientNo"
                              className="mb-1 text-sm text-[#A6A6A6] whitespace-normal words-break"
                            >
                              Is the company registered by the relevant foreign
                              registration body?
                            </label>
                            <span>{foreignRegistered}</span>
                            {foreignRegistered === "yes" && (
                              <>
                                <label
                                  htmlFor="clientNo"
                                  className="mb-1 text-sm mt-4 text-[#A6A6A6] whitespace-normal words-break"
                                >
                                  Employer Identification Number (EIN)
                                </label>
                                <span>{EIN.value}</span>
                              </>
                            )}
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Company registration number
                              </label>
                              <StatusButton
                                status={companyRegistrationNumber.status}
                                count={
                                  companyRegistrationNumber.comments?.length
                                }
                                openSection={() =>
                                  handleStatusClick(
                                    companyRegistrationNumber,
                                    "Company registration number",
                                    companyRegistrationNumber.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{companyRegistrationNumber.value}</span>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                The address of the company in its country of
                                formation, incorporation or registration as
                                registered by the relevant foreign registration
                                body
                              </label>
                              <StatusButton
                                status={foreignAddress.status}
                                count={foreignAddress.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    foreignAddress,
                                    "Country of formation's address",
                                    foreignAddress?.value?.google_address,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{foreignAddress?.value?.google_address}</span>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                      <div className="flex flex-col px-4 pt-4">
                        {(accountType == 1 || accountType == 2) && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Registered by ASIC as
                              </label>
                              <StatusButton
                                status={companyTypeText.status}
                                count={companyTypeText.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    companyTypeText,
                                    "Registered by ASIC as",
                                    companyTypeText?.value?.name,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{companyTypeText?.value?.name}</span>
                          </>
                        )}
                        {accountType == 3 && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Type Of Company
                              </label>
                              <StatusButton
                                status={companyTypeText.status}
                                count={companyTypeText.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    companyTypeText,
                                    "Type Of Company",
                                    companyTypeText?.value?.name,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{companyTypeText.value.name}</span>
                            <label
                              htmlFor="applicantCountry"
                              className="mb-1 text-sm text-[#A6A6A6] mt-4"
                            >
                              Company’s Domicile Country
                            </label>
                            <span>{countryCodeText.value.name}</span>
                          </>
                        )}
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            Address of the Company's Registered Office
                          </label>
                          <StatusButton
                            status={registeredAddress.status}
                            count={registeredAddress.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                registeredAddress,
                                "Address of the Company's Registered Office",
                                registeredAddress?.value?.google_address,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{registeredAddress?.value?.google_address}</span>
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            Address of the Company's Principal place of business
                          </label>
                          <StatusButton
                            status={principalAddress.status}
                            count={principalAddress.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                principalAddress,
                                "Address of the Company's Registered Office",
                                principalAddress?.value?.google_address,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{principalAddress?.value?.google_address}</span>
                      </div>
                      <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        {accountType == 1 && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                State or Territory in Australia
                              </label>
                              <StatusButton
                                status={stateText.status}
                                count={stateText.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    stateText,
                                    "State or Territory in Australia",
                                    stateText?.value?.name,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{stateText?.value?.name}</span>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                ABN
                              </label>
                              <StatusButton
                                status={abn?.status}
                                count={abn?.comments?.length}
                                openSection={() =>
                                  handleStatusClick(abn, "ABN", abn?.value, "")
                                }
                              />
                            </div>
                            <span>{abn?.value}</span>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                ACN
                              </label>
                              <StatusButton
                                status={acn?.status}
                                count={acn?.comments?.length}
                                openSection={() =>
                                  handleStatusClick(acn, "ACN", acn?.value, "")
                                }
                              />
                            </div>
                            <span>{acn?.value}</span>
                          </>
                        )}
                        {accountType == 3 && (
                          <>
                            {" "}
                            <label
                              htmlFor="businessName"
                              className="mb-1 text-sm text-[#A6A6A6] whitespace-normal words-break"
                            >
                              Is your company listed under an Australian
                              Comparable Stock Exchange?
                            </label>
                            <span>{stockRegistered}</span>
                            {stockRegistered == "Yes" && (
                              <>
                                <div className="flex mt-2 items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center"
                                  >
                                    Relevant Stock Exchange
                                  </label>
                                  <StatusButton
                                    status={stockExchangeText.status}
                                    count={stockExchangeText.comments?.length}
                                    openSection={() =>
                                      handleStatusClick(
                                        stockExchangeText,
                                        "Relevant Stock Exchange",
                                        stockExchangeText.value,
                                        "",
                                      )
                                    }
                                  />
                                </div>
                                <span>{stockExchangeText.value}</span>
                              </>
                            )}
                          </>
                        )}
                        {accountType != 1 && (
                          <>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                ARBN
                              </label>
                              <StatusButton
                                status={arbn.status}
                                count={arbn.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    arbn,
                                    "ARBN",
                                    arbn.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{arbn.value}</span>
                          </>
                        )}
                      </div>
                      <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            The Name of the Company’s Secretary
                          </label>
                          <StatusButton
                            status={companySecretary.status}
                            count={companySecretary.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                companySecretary,
                                "The Name of the Company’s Secretary",
                                companySecretary.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{companySecretary.value}</span>
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center"
                          >
                            Company Website
                          </label>
                          <StatusButton
                            status={companyWebsite.status}
                            count={companyWebsite.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                companyWebsite,
                                "Company Website",
                                companyWebsite.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{companyWebsite.value}</span>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b">
                      <div className="flex flex-col px-4 pt-4">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            Default Investment Currency
                          </label>
                          <StatusButton
                            status={toCurrencyText.status}
                            count={toCurrencyText.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                toCurrencyText,
                                "Default Investment Currency",
                                toCurrencyText?.value?.name,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{toCurrencyText?.value?.name}</span>
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            Nature and level of the intended transaction
                            behaviour
                          </label>
                          <StatusButton
                            status={transactionLevel.status}
                            count={transactionLevel.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                transactionLevel,
                                "Nature and level of the intended transaction behaviour",
                                transactionLevel.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{transactionLevel.value}</span>
                      </div>
                      <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            Source of the funds including its origin
                          </label>
                          <StatusButton
                            status={source.status}
                            count={source.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                source,
                                "Source of the funds including its origin",
                                source.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{source.value}</span>
                      </div>
                      <div className="flex lg:pt-4 pt-0 flex-col pr-4">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            Expected Investment Amount
                          </label>
                          <StatusButton
                            status={investmentAmount?.status}
                            count={investmentAmount?.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                investmentAmount,
                                "Expected Investment Amount",
                                investmentAmount?.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{investmentAmount?.value}</span>
                      </div>
                    </div>
                    {accountType != 1 && (
                      <>
                        <div className="flex items-center border-b border-colour-custom space-x-2 px-4 mt-4">
                          <h1 className="text-xl font-medium mb-2">
                            Details of the company's local agent in Australia
                            (if any)
                          </h1>
                        </div>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
                          <div className="flex flex-col px-4 pt-4">
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Full Name
                              </label>
                              <StatusButton
                                status={agentName.status}
                                count={agentName.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    agentName,
                                    "Full Name",
                                    agentName.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{agentName.value}</span>
                          </div>
                          <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Address
                              </label>
                              <StatusButton
                                status={agentAddress.status}
                                count={agentAddress.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    agentAddress,
                                    "Address",
                                    agentAddress?.value?.google_address,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{agentAddress?.value?.google_address}</span>
                          </div>
                          <div className="flex lg:pt-4 pt-0 flex-col pr-4"></div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {/* End  */}
                {/* Shareholders and directors section */}
                <div className="bg-white mt-4 border rounded-md p-4">
                  <div className="border-b">
                    {/* Header */}
                    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between border-b border-colour-custom px-4 pb-2 mb-4 gap-2">
                      <div className="flex items-center gap-2">
                        <img
                          src="/people.svg"
                          alt="User Avatar"
                          className="h-6 w-6"
                        />
                        <h1 className="text-xl font-medium">
                          Directors:{" "}
                          <span className="text-[#8C8C8C] font-medium">
                            {firstNameSignup} {lastNameSignup}
                          </span>
                        </h1>
                      </div>
                      <div className="flex flex-col sm:flex-row gap-1 sm:gap-2 items-start sm:items-center">
                        <span className="text-sm text-[#A6A6A6]">
                          Number of directors within your organisation:
                        </span>
                        <span className="text-sm font-medium text-black">
                          <div className="font-semibold">
                            <div className="flex items-center text-sm mt-1 md:mt-0 space-x-0 ml-1  bg-white shadow-md">
                              {/* Count display */}
                              <span className="text-sm font-medium bg-gray-400 rounded-lg text-white p-2">
                                {members.length.toString().padStart(2, "0")}
                              </span>
                            </div>
                          </div>
                        </span>
                      </div>
                    </div>
                    {/* Directors Table */}
                    <div className="overflow-x-auto">
                      <table className="min-w-[800px] w-full text-sm text-left border rounded overflow-hidden">
                        <thead className="bg-[#F9F9F9] text-[#A6A6A6] font-semibold">
                          <tr>
                            <th className="p-2 w-[40px]"></th>
                            <th className="p-2">First Name</th>
                            <th className="p-2">Last Name</th>
                            <th className="p-2">Email Address</th>
                            <th className="p-2">Mobile Number</th>
                            <th className="p-2">Managing Member</th>
                            <th className="p-2">Status</th>
                            <th className="p-2"></th>
                          </tr>
                        </thead>
                        <tbody>
                          {members.map((member, idx) => (
                            <tr
                              key={idx}
                              className="border-t bg-white align-top"
                            >
                              <td className="p-2 font-medium text-[#A6A6A6]">
                                {(idx + 1).toString().padStart(2, "0")}.
                              </td>
                              <td className="p-2 font-medium">
                                <span>{member.firstName}</span>
                              </td>
                              <td className="p-2 font-medium">
                                <span>{member.lastName}</span>
                              </td>
                              <td className="p-2 font-medium">
                                <span>{member.email}</span>
                              </td>
                              <td className="p-2 font-medium">
                                <span>
                                  {member.countryCode} {member.mobile}
                                </span>
                              </td>
                              <td className="p-2 flex justify-center items-center">
                                <input
                                  type="radio"
                                  name="managingMember"
                                  value={true}
                                  checked={member.managingMember == true}
                                  disabled={true}
                                  className="w-4 h-4 confirm-check-disabled border-gray-300 focus:ring-[#005a9c]"
                                />
                              </td>
                              <td className="p-2 font-medium">
                                <span>
                                  {member.status?.charAt(0).toUpperCase() +
                                    member.status?.slice(1)}
                                </span>
                              </td>
                              <td className="p-2">
                                <button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    let redirectState = {
                                      path: `/review-kyc-jointaccount/${member.userId}`,
                                      state: {
                                        from: location.pathname,
                                        historyStack: [
                                          ...(location.state?.historyStack ||
                                            []),
                                          location.pathname,
                                        ],
                                      },
                                    };
                                    sessionStorage.setItem(
                                      "redirectAfterLogin",
                                      JSON.stringify(redirectState),
                                    );
                                    navigate(
                                      `/review-kyc-jointaccount/${member.userId}`,
                                      {
                                        state: {
                                          from: location.pathname,
                                          historyStack: [
                                            ...(location.state?.historyStack ||
                                              []),
                                            location.pathname,
                                          ],
                                        },
                                      },
                                    );
                                  }}
                                  className="px-3 py-1 rounded-lg  border bg-[#D3D3D3] text-[#9C9C9C] font-medium"
                                >
                                  View Application
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                    {/* Signatory Section */}
                    {members.length > 0 && (
                      <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
                        {/* Signatory Type */}
                        <div className="flex flex-col px-2 pt-4">
                          <label
                            htmlFor="applicantCountry"
                            className="mb-1 text-sm text-[#A6A6A6]"
                          >
                            Signatory Type
                          </label>
                          <span>{signatoryTypeLabel}</span>
                        </div>

                        {/* Signatories */}
                        <div className="flex flex-col px-2 pt-4 border-t md:border-t-0 md:border-l border-gray-300">
                          {signatoryType === 1 && (
                            <>
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  Signatory/Signatories
                                </label>
                                <StatusButton
                                  status={signatories.status}
                                  count={signatories.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      signatories,
                                      "Signatory/Signatories",
                                      preselectedSignatory.label,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              <span>{preselectedSignatory.label}</span>
                            </>
                          )}
                          {signatoryType === 2 && (
                            <>
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  Signatory/Signatories
                                </label>
                                <StatusButton
                                  status={signatories.status}
                                  count={signatories.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      signatories,
                                      "Signatory/Signatories",
                                      preselectedSignatory.label,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              {selectedOptions
                                ?.map((option) => option.label)
                                .join(", ")}
                            </>
                          )}

                          {signatoryType === 3 && (
                            <>
                              <div className="flex items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center"
                                >
                                  Signatory/Signatories
                                </label>
                                <StatusButton
                                  status={signatories.status}
                                  count={signatories.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      signatories,
                                      "Signatory/Signatories",
                                      preselectedSignatory.label,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              {selectedOptions
                                ?.map((option) => option.label)
                                .join(", ")}{" "}
                            </>
                          )}
                        </div>
                        <div className="flex flex-col px-2 pt-4">
                          <div className="flex mt-2 items-center justify-between">
                            <label
                              htmlFor="investmentType"
                              className="text-sm text-[#A6A6A6] flex items-center"
                            >
                              Board Resolution
                            </label>
                            <StatusButton
                              status={fileAttorney?.status}
                              count={fileAttorney?.comments?.length}
                              openSection={() =>
                                handleStatusClick(
                                  fileAttorney,
                                  "Board Resolution",
                                  fileAttorney?.value,
                                  "file",
                                )
                              }
                            />
                          </div>
                          {fileAttorney && fileAttorney.value && (
                            <div
                              onClick={(e) => {
                                e.preventDefault();
                                handleFileClick(fileAttorney.value);
                              }}
                              className="underline cursor-pointer mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2"
                            >
                              <div className="flex-col flex">
                                <span className="text-black">
                                  {fileAttorney.value.file_name}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                    <div className="flex items-center border-b border-colour-custom space-x-2 px-4">
                      <h1 className="text-lg font-medium mb-2">
                        Transaction Limit
                      </h1>
                    </div>
                    <div className="mt-4 border-t grid grid-cols-1 md:grid-cols-3 gap-4">
                      {/* Signatory Type */}
                      <div className="flex flex-col px-2 pt-4">
                        <label
                          htmlFor="applicantCountry"
                          className="mb-1 text-sm text-[#A6A6A6]"
                        >
                          Duration
                        </label>
                        <span>{limitDurationLabel}</span>
                      </div>
                      <div className="flex flex-col px-2 pt-4 md:border-r md:border-t-0 md:border-l border-gray-300">
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center"
                          >
                            Amount in Dollars ($)
                          </label>
                          <StatusButton
                            status={minimumInvestment?.status}
                            count={minimumInvestment?.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                minimumInvestment,
                                "Amount in Dollars ($)",
                                minimumInvestment?.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{minimumInvestment?.value}</span>
                      </div>

                      <div className="flex flex-col px-2 pt-4">
                        <div className="flex mt-2 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                          >
                            Transaction Limit Expiry Date
                          </label>
                          <StatusButton
                            status={customDate?.status}
                            count={customDate?.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                customDate,
                                "Transaction Limit Expiry Date",
                                customDate?.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>
                          {customDate.value == "never"
                            ? "Never"
                            : formatDate(customDate?.value)}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="bg-white  rounded-md mt-4">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between space-y-2 md:space-y-0 px-2">
                      <div className="flex items-center space-x-2">
                        <img
                          src="/people.svg"
                          alt="User Avatar"
                          className="h-6 w-6"
                        />
                        <h1 className="text-xl font-medium">
                          Shareholders:
                          <span className="text-xl font-medium text-[#8C8C8C] ml-1">
                            {firstNameSignup} {lastNameSignup}
                          </span>
                        </h1>
                      </div>
                      <div className="flex space-x-2">
                        <button
                          onClick={() => {
                            setShowVisualLink(true);
                          }}
                          className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                        >
                          <img
                            src="/hashtag.svg"
                            alt="Collapse Icon"
                            className="w-4 h-4 flex-shrink-0"
                          />
                          <span className="font-medium">Visual Link</span>
                        </button>
                        <button
                          onClick={handleCollapseAll}
                          className="bg-white text-black text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                        >
                          <img
                            src="/arrow-square-up.svg"
                            alt="Collapse Icon"
                            className="w-4 h-4 flex-shrink-0"
                          />
                          <span className="font-medium">Collapse All</span>
                        </button>
                        <button
                          onClick={handleExpandAll}
                          className="bg-black text-white text-sm px-3 py-2 rounded-xl border shadow-md flex items-center space-x-2"
                        >
                          <img
                            src="/arrow-square-down.svg"
                            alt="Collapse Icon"
                            className="w-4 h-4 flex-shrink-0"
                          />
                          <span className="font-medium">Expand All</span>
                        </button>
                      </div>
                    </div>
                    {showVisualLink && (
                      <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-[99999]">
                        <div className="relative bg-white rounded-2xl shadow-2xl w-[95%] md:w-[900px] p-6">
                          {/* Close Button */}
                          <button
                            onClick={() => setShowVisualLink(false)}
                            className="absolute top-3 right-3 text-gray-600 hover:text-black text-2xl font-bold transition-colors"
                          >
                            &times;
                          </button>

                          {/* Graph */}
                          <div className="mt-6 w-full h-[500px] border border-gray-200 rounded-xl overflow-hidden">
                            <MindmapTree data={data} />
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="pt-2">
                      {layers.map((layer) => (
                        <ShareholderLayer
                          key={layer.id}
                          layer={layer}
                          collapsed={collapsedLayers[layer.id] ?? false}
                          onToggle={() =>
                            setCollapsedLayers((prev) => ({
                              ...prev,
                              [layer.id]: !prev[layer.id],
                            }))
                          }
                        />
                      ))}
                    </div>
                  </div>
                </div>{" "}
                {/* Connect Bank Account */}
                <div className="w-full  p-4">
                  <div className="mt-2 border pb-4 pt-2 rounded-md">
                    <div className="flex items-center justify-between border-colour-custom pt-2 px-4">
                      <div className="flex text-black items-center space-x-2">
                        <img
                          src="/cards.svg"
                          alt="User Avatar"
                          className="h-6 w-6 mb-2"
                        />
                        <h1 className="text-md font-medium mb-2">
                          {" "}
                          Connect External Bank Account
                        </h1>
                      </div>
                    </div>
                    {bankdata.map((bank, index) => (
                      <div className="mt-1 border pb-4 pt-2 mx-4 rounded-md">
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                          <div className="flex flex-col px-4 md:pl-4 md:pr-0 pt-4 ">
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Account Holder Name
                              </label>
                              <StatusButton
                                status={bank.account_name.status}
                                count={bank.account_name.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    bank.account_name,
                                    "Account Holder Name",
                                    bank.account_name.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <div className="mt-0 text-sm ">
                              {bank.account_name.value}
                            </div>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Account Number or IBAN
                              </label>
                              <StatusButton
                                status={bank.account_number.status}
                                count={bank.account_number.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    bank.account_number,
                                    "Account Number or IBAN",
                                    bank.account_number.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <div className="mt-0 text-sm">
                              {bank.account_number.value}
                            </div>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Bank Name
                              </label>
                              <StatusButton
                                status={bank.bank_name.status}
                                count={bank.bank_name.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    bank.bank_name,
                                    "Bank Name",
                                    bank.bank_name.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <div className="mt-0 text-sm">
                              {bank.bank_name.value}
                            </div>
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Swift Code
                              </label>
                              <StatusButton
                                status={bank.swift_code.status}
                                count={bank.swift_code.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    bank.swift_code,
                                    "Swift Code",
                                    bank.swift_code.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <div className="mt-2 text-sm">
                              {bank.swift_code.value}
                            </div>
                          </div>
                          <div className="flex flex-col lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Branch Identifier
                              </label>
                              <StatusButton
                                status={bank.branch_identifier.status}
                                count={bank.branch_identifier.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    bank.branch_identifier,
                                    "Branch Identifier",
                                    bank.branch_identifier.value.name,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <div className="mt-0 text-sm">
                              {bank.branch_identifier.value.name}
                            </div>
                            {bank.branch_identifier.value.id == 1 && (
                              <>
                                <div className="flex mt-2 items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                  >
                                    BSB (AUS Only)
                                  </label>
                                  <StatusButton
                                    status={bank.account_bsb.status}
                                    count={bank.account_bsb.comments?.length}
                                    openSection={() =>
                                      handleStatusClick(
                                        bank.account_bsb,
                                        "BSB (AUS Only)",
                                        bank.account_bsb.value,
                                        "",
                                      )
                                    }
                                  />
                                </div>
                                <div className="mt-0 text-sm">
                                  {bank.account_bsb.value}
                                </div>
                              </>
                            )}
                            {bank.branch_identifier.value.id == 2 && (
                              <>
                                <div className="flex mt-2 items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                  >
                                    Country{" "}
                                  </label>
                                  <StatusButton
                                    status={bank.country_code.status}
                                    count={bank.country_code.comments?.length}
                                    openSection={() =>
                                      handleStatusClick(
                                        bank.country_code,
                                        " Country",
                                        bank.country_code.value,
                                        "",
                                      )
                                    }
                                  />
                                </div>
                                <div className="mt-0 text-sm">
                                  {bank.country_code.value}
                                </div>
                                {bank.country_code.value == "CA" && (
                                  <>
                                    <div className="flex mt-2 items-center justify-between">
                                      <label
                                        htmlFor="investmentType"
                                        className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                      >
                                        Financial Institution Identifier{" "}
                                      </label>
                                      <StatusButton
                                        status={bank.institution_number.status}
                                        count={
                                          bank.institution_number.comments
                                            ?.length
                                        }
                                        openSection={() =>
                                          handleStatusClick(
                                            bank.institution_number,
                                            "Financial Institution Identifier",
                                            bank.institution_number.value,
                                            "",
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="mt-0 text-sm">
                                      {bank.institution_number.value}
                                    </div>
                                    <div className="flex mt-2 items-center justify-between">
                                      <label
                                        htmlFor="investmentType"
                                        className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                      >
                                        Transit Number{" "}
                                      </label>
                                      <StatusButton
                                        status={bank.transit_number.status}
                                        count={
                                          bank.transit_number.comments?.length
                                        }
                                        openSection={() =>
                                          handleStatusClick(
                                            bank.transit_number,
                                            "Transit Number",
                                            bank.transit_number.value,
                                            "",
                                          )
                                        }
                                      />
                                    </div>
                                    <div className="mt-0 text-sm">
                                      {bank.transit_number.value}
                                    </div>
                                  </>
                                )}
                              </>
                            )}
                            {bank.branch_identifier.value.id == 3 && (
                              <>
                                <div className="flex mt-2 items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                  >
                                    Routing Number
                                  </label>
                                  <StatusButton
                                    status={bank.routing_number.status}
                                    count={bank.routing_number.comments?.length}
                                    openSection={() =>
                                      handleStatusClick(
                                        bank.routing_number,
                                        "Routing Number",
                                        bank.routing_number.value,
                                        "",
                                      )
                                    }
                                  />
                                </div>
                                <div className="mt-0 text-sm">
                                  {bank.routing_number.value}
                                </div>
                                <div className="flex mt-2 items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                  >
                                    Active{" "}
                                  </label>
                                </div>
                                <div className="mt-0 text-sm">
                                  {bank.is_active.value == true ? "Yes" : "No"}
                                </div>
                                <div className="flex mt-2 items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                  >
                                    Default{" "}
                                  </label>
                                </div>
                                <div className="mt-0 text-sm">
                                  {bank.is_default.value == true ? "Yes" : "No"}
                                </div>
                              </>
                            )}
                            {bank.branch_identifier.value.id != 1 && (
                              <>
                                <div className="flex mt-2 items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                  >
                                    Payment Method
                                  </label>
                                  <StatusButton
                                    status={bank.payment_method.status}
                                    count={bank.payment_method.comments?.length}
                                    openSection={() =>
                                      handleStatusClick(
                                        bank.payment_method,
                                        "Payment Method",
                                        bank.payment_method.value.name,
                                        "",
                                      )
                                    }
                                  />
                                </div>
                                <div className="mt-0 text-sm">
                                  {bank.payment_method.value.name}
                                </div>
                              </>
                            )}
                          </div>
                          <div className="flex lg:pt-4 pt-0 flex-col px-4">
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Currency
                              </label>
                              <StatusButton
                                status={bank.currency.status}
                                count={bank.currency.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    bank.currency,
                                    "Currency",
                                    bank.currency.value.name,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <div className="mt-0 text-sm">
                              {bank.currency.value.name}
                            </div>
                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Upload Docs
                              </label>
                              <StatusButton
                                status={bank.proof_image.status}
                                count={bank.proof_image.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    bank.proof_image,
                                    "Upload Docs",
                                    bank.proof_image.value,
                                    "file",
                                  )
                                }
                              />
                            </div>
                            {bank.proof_image && bank.proof_image.value && (
                              <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                                <div
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleFileClick(bank.proof_image.value);
                                  }}
                                  className="flex-col flex "
                                >
                                  <span className="text-black break-all cursor-pointer underline">
                                    {bank.proof_image.value.file_name}
                                  </span>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="flex lg:pt-4 pt-0 flex-col px-4 sm:border-l-0  md:border-l border-gray-300">
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Address line 1
                              </label>
                              <StatusButton
                                status={bank.address_line1.status}
                                count={bank.address_line1.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    bank.address_line1,
                                    "Address line 1",
                                    bank.address_line1.value != null
                                      ? bank.address_line1.value
                                      : "",
                                    "",
                                  )
                                }
                              />
                            </div>
                            <div className="text-sm">
                              {bank.address_line1.value != null
                                ? bank.address_line1.value
                                : ""}
                            </div>
                            {bank.address_line2.value && (
                              <>
                                {" "}
                                <div className="flex items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                  >
                                    Address line 2
                                  </label>
                                  <StatusButton
                                    status={bank.address_line2.status}
                                    count={bank.address_line2.comments?.length}
                                    openSection={() =>
                                      handleStatusClick(
                                        bank.address_line2,
                                        "Address line 2",
                                        bank.address_line2.value != null
                                          ? bank.address_line2.value
                                          : "",
                                        "",
                                      )
                                    }
                                  />
                                </div>
                                <div className="text-sm">
                                  {bank.address_line2.value != null
                                    ? bank.address_line2.value
                                    : ""}
                                </div>
                              </>
                            )}
                            {bank.address_line3.value && (
                              <>
                                <div className="flex mt-2 items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                  >
                                    Address line 3
                                  </label>
                                  <StatusButton
                                    status={bank.address_line3.status}
                                    count={bank.address_line3.comments?.length}
                                    openSection={() =>
                                      handleStatusClick(
                                        bank.address_line3,
                                        "Address line 3",
                                        bank.address_line3.value != null
                                          ? bank.address_line3.value
                                          : "",
                                        "",
                                      )
                                    }
                                  />
                                </div>
                                <div className="text-sm">
                                  {bank.address_line3.value != null
                                    ? bank.address_line3.value
                                    : ""}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}

                    {isModalOpen && currentDocument && (
                      <DocumentPreview
                        fileUrl={currentDocument.presigned_url}
                        fileName={currentDocument.file_name}
                        onClose={() => setIsModalOpen(false)}
                      />
                    )}
                  </div>
                </div>
                {/* End */}
                {/* Cash Account Information */}
                <div className="w-full  p-4">
                  <div className="mt-2 border pb-4 pt-2 rounded-md">
                    <div className="flex flex-col md:flex-row md:items-center justify-between border-colour-custom px-4 py-2 gap-2">
                      {/* Left Section */}
                      <div className="flex items-center space-x-2">
                        <img
                          src="/money-2.svg"
                          alt="Cash Icon"
                          className="h-6 w-6"
                        />
                        <h1 className="text-md font-medium">
                          Cash Account Information
                        </h1>
                      </div>

                      {/* Right Section - Responsive */}
                      <div className="flex items-center justify-start md:justify-end gap-x-2 flex-wrap">
                        <div className="flex flex-col items-start md:items-end">
                          <span className="text-sm font-semibold text-[#464646] leading-tight">
                            No. Of Cash Account
                          </span>
                        </div>
                        <span className="text-md font-semibold hidden md:inline">
                          |
                        </span>
                        <span className="text-sm font-semibold rounded-md text-white py-1 px-3 bg-[#34C046]">
                          {String(accounts.length).padStart(2, "0")}
                        </span>
                      </div>
                    </div>
                    {/* Will add popup here */}

                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                      {Array.from({ length: accounts.length }).map(
                        (_, index) => (
                          <div key={index} className="px-4 py-2">
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Account No.
                                {String(index + 1).padStart(2, "0")}{" "}
                              </label>
                              <StatusButton
                                status={accounts[index].status}
                                count={accounts[index].comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    accounts[index].value,
                                    `Account No.${String(index + 1).padStart(2, "0")}`,
                                    accounts[index].label,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span className="text-sm">
                              {accounts[index].label}
                            </span>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
                {/* End  */}
                {/* Upload Proof Documents */}
                <div className="w-full  p-4">
                  <div className="mt-2 border pb-4 pt-2 rounded-md">
                    <div className="flex flex-wrap md:flex-nowrap items-center justify-between border-colour-custom pt-2 px-4 gap-4">
                      {/* Left Section (Title + Icon) */}
                      <div className="flex text-black items-center space-x-2">
                        <img
                          src="/note-2.svg"
                          alt="User Avatar"
                          className="h-6 w-6"
                        />
                        <h1 className="text-md font-medium">
                          Upload Proof Documents
                        </h1>
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 border-b pb-2">
                      {/* first column */}
                      <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                        {(accountType != 1 ||
                          (accountType == 1 &&
                            companyTypeText.value.id == 2)) && (
                          <>
                            <div className="flex items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6]  whitespace-normal break-words block"
                              >
                                A search/extract of the relevant Australian
                                stock exchange
                              </label>
                            </div>
                            {ticketLink.value != "" && (
                              <>
                                <div className="flex mt-2 items-center justify-between">
                                  <label
                                    htmlFor="investmentType"
                                    className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                  >
                                    Ticket Number
                                  </label>
                                  <StatusButton
                                    status={ticketLink.status}
                                    count={ticketLink.comments?.length}
                                    openSection={() =>
                                      handleStatusClick(
                                        ticketLink,
                                        "Ticket Number",
                                        ticketLink.value,
                                        "",
                                      )
                                    }
                                  />
                                </div>
                                <span>{ticketLink.value}</span>
                              </>
                            )}
                            {fileTicket && fileTicket.value && (
                              <>
                                <div className="mt-4">
                                  <FileUploadDisplay
                                    label="Uploaded File"
                                    fileData={fileTicket}
                                    onFileClick={handleFileClick}
                                  />
                                </div>
                              </>
                            )}
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="A public document issued by the company (E.g. Annual
                            General Report)"
                                fileData={filePublicDocument}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        {(accountType == 2 ||
                          (accountType == 3 && companyTypeText.value.id == 2) ||
                          (accountType == 1 &&
                            companyTypeText.value.id == 1)) && (
                          <>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label={
                                  accountType == 2
                                    ? "Valid Company Registration Certificate issued by ASIC"
                                    : "Valid Company Registration Certificate"
                                }
                                fileData={fileCompanyRegistration}
                                onFileClick={handleFileClick}
                              />
                            </div>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Disclosure certificate verifying information about the
                      beneficial ownership of the company"
                                fileData={fileDisclosure}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="Shareholder Certificate"
                            fileData={fileShareholderCertificate}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="A search/extract of the relevant ASIC database"
                            fileData={fileExtractDocument}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        {accountType != 1 && (
                          <div className="mt-4">
                            <FileUploadDisplay
                              label="Certificate of Incumbency"
                              fileData={fileCertificateOfIncumbency}
                              onFileClick={handleFileClick}
                            />
                          </div>
                        )}
                      </div>
                      {/* second column */}
                      <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
                        {(accountType == 1 ||
                          (accountType == 3 &&
                            companyTypeText.value.id == 1)) && (
                          <>
                            {" "}
                            <div className="flex flex-col md:flex-col md:items-left md:justify-between gap-2">
                              <label
                                htmlFor="investmentType"
                                className="[#A6A6A6] block whitespace-normal break-words text-sm text-[#A6A6A6] flex items-center"
                              >
                                Does your company possess a financial services
                                license?
                              </label>
                              <div className="flex items-center gap-4 opacity-50 ">
                                <label className="flex items-center text-sm text-black">
                                  <input
                                    type="radio"
                                    name="hasLicense"
                                    value={true}
                                    checked={hasLicense === true}
                                    disabled={true}
                                    className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                                  />
                                  <span className="ml-2">Yes</span>
                                </label>
                                <label className="flex items-center text-sm text-black">
                                  <input
                                    type="radio"
                                    name="hasLicense"
                                    value={false}
                                    checked={hasLicense === false}
                                    disabled={false}
                                    className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                                  />
                                  <span className="ml-2">No</span>
                                </label>
                              </div>
                              {hasLicense && (
                                <>
                                  <label
                                    htmlFor="firstName"
                                    className="mb-1 mt-4 text-sm text-[#A6A6A6]"
                                  >
                                    Licence Number
                                  </label>
                                  <span>{licenseNumber}</span>
                                  <div className="mt-4">
                                    <FileUploadDisplay
                                      label="Upload a search of the license or other
                                  records of the relevant commonwealth, state,
                                  or Territory regulator"
                                      fileData={fileLicense}
                                      onFileClick={handleFileClick}
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </>
                        )}
                        {(accountType == 2 ||
                          (accountType == 3 &&
                            companyTypeText.value.id == 2)) && (
                          <>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Valid company registration certificate issued by the
                            relevant foreign registration body"
                                fileData={fileForeignRegistration}
                                onFileClick={handleFileClick}
                              />
                            </div>

                            <div className="flex mt-2 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                              >
                                Jurisdiction of the primary operations of the
                                company
                              </label>
                              <StatusButton
                                status={jurisdiction.status}
                                count={jurisdiction.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    jurisdiction,
                                    "Jurisdiction of the primary operations of the company",
                                    jurisdiction.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{jurisdiction?.value}</span>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Valid Australian financial services license issued
                            by ASIC"
                                fileData={fileFinancialService}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center block whitespace-normal break-words"
                          >
                            If applicable, description and proof of any current
                            or recent prosecutions and inquiries related to
                            money laundering, terrorist links, tax offenses, and
                            corruption
                          </label>
                          <StatusButton
                            status={ifApplicable?.status}
                            count={ifApplicable?.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                ifApplicable,
                                "If Applicable?",
                                ifApplicable?.value == true ? "Yes" : "No",
                                "",
                              )
                            }
                          />
                        </div>
                        <div className="flex items-center gap-4 opacity-50 ">
                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value={true}
                              checked={ifApplicable.value === true}
                              disabled={true}
                              className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                            />
                            <span className="ml-2">Yes</span>
                          </label>
                          <label className="flex items-center text-sm text-black">
                            <input
                              type="radio"
                              name="signatory"
                              value={false}
                              checked={ifApplicable.value === false}
                              disabled={false}
                              className="w-4 h-4 confirm-check  border-gray-300 focus:ring-[#005a9c]"
                            />
                            <span className="ml-2">No</span>
                          </label>
                        </div>
                        {ifApplicable.value == true && (
                          <>
                            <div className="flex mt-4 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Description
                              </label>
                              <StatusButton
                                status={description?.status}
                                count={description?.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    description,
                                    "Description",
                                    description?.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{description.value}</span>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Upload Proof"
                                fileData={fileProof}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}
                        {accountType != 1 && (
                          <div className="mt-4">
                            <FileUploadDisplay
                              label="UBO Certificate"
                              fileData={fileUboCertificate}
                              onFileClick={handleFileClick}
                            />
                          </div>
                        )}
                      </div>
                      {/* third column */}
                      <div className="flex flex-col pr-4 pt-4">
                        {accountType == 1 && (
                          <>
                            <div className="">
                              <div className="flex  items-center justify-between">
                                <label
                                  htmlFor="investmentType"
                                  className="text-sm text-[#A6A6A6] flex items-center whitespace-normal words-break"
                                >
                                  ABN
                                </label>
                                <StatusButton
                                  status={abn?.status}
                                  count={abn?.comments?.length}
                                  openSection={() =>
                                    handleStatusClick(
                                      abn,
                                      "ABN",
                                      abn?.value,
                                      "",
                                    )
                                  }
                                />
                              </div>
                              <span>{abn?.value}</span>
                            </div>
                            <div className="mt-4">
                              <label
                                htmlFor="description"
                                className="mb-1 text-sm text-[#A6A6A6]"
                              >
                                ABN Status
                              </label>
                              <span>{abnStatus.value}</span>
                            </div>
                          </>
                        )}
                        {(accountType == 1 ||
                          (accountType == 3 &&
                            companyTypeText.value.id == 1)) && (
                          <>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Contracts with third parties to verify the intended
                            transaction"
                                fileData={fileThirdParty}
                                onFileClick={handleFileClick}
                              />
                            </div>
                            <div className="flex mt-4 items-center justify-between">
                              <label
                                htmlFor="investmentType"
                                className="text-sm text-[#A6A6A6] flex items-center"
                              >
                                Description
                              </label>
                              <StatusButton
                                status={thpDescription?.status}
                                count={thpDescription?.comments?.length}
                                openSection={() =>
                                  handleStatusClick(
                                    thpDescription,
                                    "Description",
                                    thpDescription?.value,
                                    "",
                                  )
                                }
                              />
                            </div>
                            <span>{thpDescription.value}</span>
                          </>
                        )}
                        {(accountType == 2 ||
                          (accountType == 3 &&
                            companyTypeText.value.id == 2)) && (
                          <>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Evidence about the activities undertaken by the
                            company"
                                fileData={fileActivityEvidence}
                                onFileClick={handleFileClick}
                              />
                            </div>
                            <div className="mt-4">
                              <FileUploadDisplay
                                label="Statement of Advise"
                                fileData={fileAdviceStatement}
                                onFileClick={handleFileClick}
                              />
                            </div>
                          </>
                        )}

                        <div className="flex mt-4 items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-[#A6A6A6] flex items-center"
                          >
                            Website Link
                          </label>
                          <StatusButton
                            status={webLink?.status}
                            count={webLink?.comments?.length}
                            openSection={() =>
                              handleStatusClick(
                                webLink,
                                "Website Link",
                                webLink?.value,
                                "",
                              )
                            }
                          />
                        </div>
                        <span>{webLink?.value}</span>
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="Accountant Certificate"
                            fileData={fileAccountantCertificate}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="Certificate of incorporation"
                            fileData={fileIncorporationCertificate}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        <div className="mt-4">
                          <FileUploadDisplay
                            label="Company Organisational Chart"
                            fileData={fileCompanyOrganisationalChart}
                            onFileClick={handleFileClick}
                          />
                        </div>
                        {accountType != 1 && (
                          <div className="mt-4">
                            <FileUploadDisplay
                              label="Articles of Association/Constitution"
                              fileData={fileArticle}
                              onFileClick={handleFileClick}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* End  */}
              </>
            )}

            <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
              {/* Right Section: Download Button */}
              <div className="flex items-center justify-end w-full">
                <div ref={dropdownRef} className="relative inline-block mr-4">
                  {/* Button */}
                  <div
                    className="flex text-sm justify-between items-center py-2 px-2 border border-white  w-40 rounded-full cursor-pointer"
                    onClick={() => setIsOpenAction(!isOpenAction)}
                  >
                    <span className="text-right pl-4 text-white">Actions</span>
                    <span className="text-gray-500">
                      {" "}
                      <img
                        src="/white-dropdown.svg"
                        alt="document-download"
                        className="pr-2"
                      />
                    </span>
                  </div>

                  {/* Dropdown Menu */}
                  {isOpenAction && (
                    <div className="absolute text-xs top-[-250%] right-0 bg-white text-black shadow-lg rounded-md w-40 p-2 z-10">
                      <ul>
                        <li
                          onClick={(e) => {
                            setLoadingUpdate(true);
                            handleUpdateApplication(e, "approve");
                          }}
                          className="p-2 hover:bg-black hover:text-white cursor-pointer"
                        >
                          Approve Application
                        </li>
                        <li
                          onClick={(e) => {
                            setLoadingUpdate(true);
                            handleUpdateApplication(e, "reject");
                          }}
                          className="p-2 hover:bg-black text-[#FF5050] hover:text-[#FF5050] cursor-pointer"
                        >
                          Reject Application
                        </li>
                        {roleName == "team" && (
                          <li
                            onClick={(e) => {
                              setLoadingUpdate(true);
                              handleUpdateApplication(e, "reject");
                            }}
                            className="p-2 hover:bg-black text-black hover:text-white cursor-pointer"
                          >
                            Send for Admin Approval
                          </li>
                        )}
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
            {showPopup && currentField && (
              <ReviewPopup
                isOpen={showPopup}
                currentField={currentField}
                currentFieldName={currentFieldName}
                currentFieldValue={currentFieldValue}
                currentFieldType={currentFieldType}
                onClose={() => setShowPopup(false)}
              />
            )}
          </div>
        </>
      )}
    </div>
  );
};
const ShareholderLayer = ({ layer, collapsed, onToggle }) => {
  const { layerName, groups, hasTabs } = layer;
  const isOpen = !collapsed;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState(0);
  const rowsToRender = hasTabs
    ? groups[activeTab]?.shareholders || []
    : groups[0]?.shareholders || [];
  const calculateSharesCounter = (list) =>
    list.reduce((acc, s) => acc + Number(s.shares || 0), 0).toFixed(2);

  useEffect(() => {
    setActiveTab(0);
  }, [groups]);

  const currentRows = groups[activeTab]?.shareholders || [];

  return (
    <div className="border rounded-2xl shadow-sm bg-white mb-6">
      {/* Header */}
      <div
        onClick={onToggle}
        className="bg-[#464646] text-white px-4 py-2 rounded-t-2xl flex justify-between items-center cursor-pointer"
      >
        <h2 className="text-sm font-medium">{layerName}</h2>
        <span className="text-lg">{isOpen ? "−" : "+"}</span>
      </div>

      {isOpen && (
        <>
          {/* Tabs ONLY when groups > 1 */}
          {hasTabs && (
            <div className="flex border-b">
              {groups.map((g, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveTab(idx)}
                  className={`px-4 py-2 text-sm font-medium ${
                    activeTab === idx
                      ? "bg-black text-white"
                      : "bg-gray-100 text-gray-600"
                  }`}
                >
                  {g.parent?.name}
                </button>
              ))}
            </div>
          )}

          {/* Table */}
          <div className="p-4 border rounded-b-lg">
            <div className="overflow-x-auto">
              <table className="w-full text-sm  text-[#8C8C8C]">
                <thead>
                  <tr className="border">
                    <th className="p-2"></th>
                    <th className="p-2 text-left font-medium">
                      Shareholder Name
                    </th>
                    <th className="p-2 text-left font-medium">Type</th>
                    <th className="p-2 text-left font-medium">Shares(%)</th>
                    <th className="p-2 text-left font-medium">Email</th>
                    <th className="p-2 text-left font-medium">
                      User Registration
                    </th>
                    <th className="p-2 text-left font-medium">Status</th>
                  </tr>
                </thead>
                <tbody>
                  {rowsToRender.map((s, idx) => (
                    <tr key={s.id} className="border-t font-medium text-black">
                      <td className="p-2 text-[#8C8C8C]">
                        {String(idx + 1).padStart(2, "0")}.
                      </td>
                      <td className="p-2">{s.name}</td>
                      <td className="p-2">{s.typeName}</td>
                      <td className="p-2">{s.shares}</td>
                      <td className="p-2">{s.email}</td>
                      <td className="p-2">
                        {s.shares >= 25 ? (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              let redirectState = {
                                path:
                                  s.type == 1
                                    ? `/review-kyc-jointaccount/${s.userId}`
                                    : s.type == 2
                                      ? `/review-kyc-corporate-shareholder/${s.userId}`
                                      : `/review-kyc-trust-shareholder/${s.userId}`,
                                state: {
                                  from: location.pathname,
                                  historyStack: [
                                    ...(location.state?.historyStack || []),
                                    location.pathname,
                                  ],
                                },
                              };
                              sessionStorage.setItem(
                                "redirectAfterLogin",
                                JSON.stringify(redirectState),
                              );
                              navigate(
                                s.type == 1
                                  ? `/review-kyc-jointaccount/${s.userId}`
                                  : s.type == 2
                                    ? `/review-kyc-corporate-shareholder/${s.userId}`
                                    : `/review-kyc-trust-shareholder/${s.userId}`,
                                {
                                  state: {
                                    from: location.pathname,
                                    historyStack: [
                                      ...(location.state?.historyStack || []),
                                      location.pathname,
                                    ],
                                  },
                                },
                              );
                            }}
                            className="px-3 py-1 rounded-lg  border bg-[#D3D3D3] text-[#9C9C9C] font-medium"
                          >
                            View Application
                          </button>
                        ) : (
                          <span className="text-gray-400">—</span>
                        )}
                      </td>
                      <td className="p-2">
                        {s.status
                          ?.replaceAll("_", " ")
                          ?.replace(/\b\w/g, (c) => c.toUpperCase())}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default ReviewKYCCorporate;
